export class DataDefinition {
    Id: number;
    LookupListId?: number;
    Code: string;
    Description?: string;
    Inactive?: boolean;
    IsDefault?: boolean;
    Abbreviation?: string;
    IsStateReporting?: boolean;
    StateReportingCodeId?: string;
    StateIdentifier?: string;
    Sequence?: number;
    YearId?: number;
    SiteYearId?: number;
    MasterId?: number;
    IsSysGen?: boolean;
    IsSelected?: boolean;
}

export class DataDefinitionList {
    Id: number;
    Name: string;
    LookupListCategoryId: number;
    LookupListCategoryName = '';
    TableName = '';
    GetSPName = '';
    SetSPName = '';
    DeleteSPName = '';
    IsSysGen = false;
    ShowUsedForStateReporting = false;
    StateReportingType: number;
    CodeMinLength = 0;
    CodeMaxLength = 50;
    IsDynamic = false;
    MetaData = '';
    Enum = '';
    DataDefinitions: DataDefinition[];
    Type = '';
    NotVisible = false;
    InUse = false;
    CodeNotRequired = false;
    ReadOnly = false;
    IsSortable = false;
    ExclusiveTo360: boolean;
    ImportedFromClassic: boolean;
    DescriptionMaxLength = 50;
    UserCanEdit: boolean;
    ShowCodeField: boolean;
    ShowDescriptionField: boolean;
    ShowStatusField: boolean;
    ShowDefaultField: boolean;
    ShowAbbreviationField: boolean;
    LockSystemCodes: boolean;
}

export class DataDefinitionDynamic {
    LookupValuesJSON: string;
}

export class DataDefinitionDynamicColumn {
    ColumnName: string;
    DisplayName: string;
    DataType: string;
    ControlType: string;
    Required: boolean;
    Editable: boolean;
    MinLength: number;
    MaxLength: number;
    DisplayOnGrid: boolean;
    DisplayOnForm: boolean;
    GridSequence: number;
    FormSequence: number;
    Cell: any;

    constructor(columnName: string, displayName: string, dataType: string, controlType: string, required: boolean, editable: boolean,
        minLength: number, maxLength: number, displayOnGrid: boolean, displayOnForm: boolean,
        gridSequence: number, formSequence: number, cell: string) {
        this.ColumnName = columnName;
        this.DisplayName = displayName;
        this.DataType = dataType;
        this.ControlType = controlType;
        this.Required = required;
        this.Editable = editable;
        this.MinLength = minLength;
        this.MaxLength = maxLength;
        this.DisplayOnGrid = displayOnGrid;
        this.DisplayOnForm = displayOnForm;
        this.GridSequence = gridSequence;
        this.FormSequence = formSequence;
        this.Cell = (element: any) => `${element[cell]}`;
    }
}

export class DataDefinitionCategory {
    Id: number;
    Name: string;
}